export default __webpack_public_path__ + "locales/ko-KR/UploadPanel.json?hash=b48af8ad00d170659d5ab1c633b6db56";